import Post from "../../types/Post";
import { itemsMenuHierarch } from "../../utils/menuHierarch";
import styles from "./commentsList.module.scss";

interface ComponentTypes {
  items: Post;
  count: number | null;
}

interface Comments {
  approved: boolean;
  author: {
    node: {
      name: string;
    };
  };
  children: Array<Children>;
  commentId: number;
  content: string;
  databaseId: number;
  date: string;
  id: string;
  parentDatabaseId: number;
  parentId: number | null;
  replies: {
    nodes: Array<Children>;
  };
}
interface Children {
  approved: true;
  author: {
    node: {
      name: string;
    };
  };
  children?: Array<Children>;
  commentId: number;
  content: string;
  databaseId: number;
  date: string;
  id: string;
  parentDatabaseId: number;
  parentId: string;
}

export const CommentsList = ({ items, count }: ComponentTypes) => {
  // @ts-ignore
  const comments = itemsMenuHierarch(items.comments.nodes);

  return (
    <div className={styles.commentsWrapper}>
      <h3 id={styles.comments}>
        {count ?? 0} {count === 1 ? "resposta" : "respostas"} para “
        {items.title}”:
      </h3>

      <ol className={styles.commentlist}>
        {comments.length > 0 ? (
          comments.map((item: Comments) => {
            const children = item.children;
            return (
              <li
                key={item.id}
                className={[styles.comment, styles.parent].join(" ")}
              >
                <article className={styles.commentBody}>
                  <footer className={styles.commentMeta}>
                    <div className={styles.commentAuthor}>
                      <b>{item.author?.node?.name}</b> <span>disse:</span>
                    </div>

                    <div className={styles.commentMetadata}>
                      <div>
                        <time dateTime={item.date}>{item.date}</time>
                      </div>
                    </div>
                  </footer>
                  <div className={styles.commentContent}>
                    <div dangerouslySetInnerHTML={{ __html: item.content }} />
                  </div>
                </article>
                <ul className={styles.children}>
                  {children.length > 0 &&
                    children.map((reply: Children) => {
                      return (
                        <li key={reply.id} className={styles.comment}>
                          <article className={styles.commentBody}>
                            <footer className={styles.commentMeta}>
                              <div className={styles.commentAuthor}>
                                <b>{reply?.author?.node?.name || "FinanZero"}</b> <span>disse:</span>
                              </div>

                              <div className={styles.commentMetadata}>
                                <div>
                                  <time dateTime={reply.date}>{item.date}</time>
                                </div>
                              </div>
                            </footer>
                            <div className={styles.commentContent}>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: reply.content,
                                }}
                              />
                            </div>
                          </article>
                        </li>
                      );
                    })}
                </ul>
              </li>
            );
          })
        ) : (
          <li className={styles.noComment}>
            Não existe nenhum comentário nesse post ainda. Seja o primeiro!
          </li>
        )}
      </ol>
    </div>
  );
};
